import React, { useState,useEffect } from 'react'
import "../InfoProfile/Info.css"
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';

import {LiaEdit} from "react-icons/lia"
import { API_BASE_URL, API_KEY } from '../../../../constants';
import {IoCameraOutline} from "react-icons/io5"
import { useRef } from 'react';
import axiosInstance from "../../../../axios"

const Info = ({userPostData,
              following,
              modelDetails,
              setModelDetails,
              profileImg,
              coverImg,
              setProfileImg,
              setCoverImg,
              name,
              setName,
              userName,
              setUserName,
              EditMemberButtonVisibility,
              loggedInUserId,
              isSuperUser}) => {

  const importProfile=useRef()
  const importCover =useRef()
  const [members_count,setMembers]=useState(0)
  //const [EditMemberButtonVisibility,setEditMemberButtonVisibility]=useState(false)
  // const logged_in_user_obj=JSON.parse(localStorage.getItem('userData'))
  // const logged_in_user_id=logged_in_user_obj.user_profile.member_id
  // const is_super_user=logged_in_user_obj.user_profile.is_superuser
  const get_family_api_url= `family-members/`;
  // const get_member_owner_url='api/v1/member-owners/?search='

  useEffect(() => {
    const fetchDataAndSetFields = async () => {
  
        try {
          const responseData = await axiosInstance.get(API_BASE_URL+get_family_api_url+modelDetails.ModelId);
          if(responseData && responseData.data){
          setMembers(responseData.data.data.length+1)}
            
        }
       catch (error) {
          console.error("An error occurred while fetching data:", error);
        }
      };

      // const fetchOwnerDetails = async () => {
  
      //   try {
      //     const responseData = await get(get_member_owner_url+modelDetails.ModelId);
      //     if(responseData && responseData.data && responseData.data[0]){
      //         const owner_id=responseData.data[0].rel_member.member_id
      //         if(loggedInUserId==owner_id || isSuperUser)
      //         {
      //           setEditMemberButtonVisibility(false)
      //         }
      //         else{
      //           setEditMemberButtonVisibility(true)
      //         }
      //       }
      //     else{
      //       setEditMemberButtonVisibility(true)
      //     }
            
      //   }
      //  catch (error) {
      //     console.error("An error occurred while fetching data:", error);
      //   }
      // };
      fetchDataAndSetFields();
      // fetchOwnerDetails();
  }, []);
  
  const handleFile1=async (e) =>{
    e.preventDefault();
    if(e.target.files && e.target.files[0]){
      let img =e.target.files[0]
      const imgObj= {image:URL.createObjectURL(img)}
      const profileImg= imgObj.image
      setProfileImg(profileImg)
      try {
        let formData = new FormData();
        formData.append("profile_pic", img);

        const response = await axiosInstance.post(
          `${API_BASE_URL}profile-pic/`+modelDetails.ModelId,formData,
          {
            headers: {
              'X-Api-Key': API_KEY,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        alert("Profile Pic uploaded Successfully!")
        // Handle response as needed

      } catch (error) {
        console.error('Uploading profile pic:', error);
      }
      if(loggedInUserId==modelDetails.ModelId){
      const update_profile_pic=async () =>{
        try {
    
            const response = await axiosInstance.get(
              `${API_BASE_URL}profile-pic/`+modelDetails.ModelId,
              {
                headers: {
                  'X-Api-Key': API_KEY,
                  "Content-Type": "multipart/form-data",
                },
              }
            );
            setProfileImg(response.data.data.profile_pic)
            const new_url=response.data.data.profile_pic
            const userData = JSON.parse(localStorage.getItem('userData')) 
            userData.member_details.profile_pic =new_url
            localStorage.setItem('userData', JSON.stringify(userData));
            // Handle response as needed
    
          } catch (error) {
            console.error('Uploading profile pic:', error);
          }
        }
        update_profile_pic();
      }
    }
  }

  const handleFile2 =async(e)=>{
    if(e.target.files && e.target.files[0]){
      let img =e.target.files[0]
      const imgObj ={image:URL.createObjectURL(img)}
      const coverImg =imgObj.image
      setCoverImg(coverImg)
      try {
        let formData = new FormData();
        formData.append("cover_pic", img);

        const response = await axiosInstance.post(
          `${API_BASE_URL}cover-pic/`+modelDetails.ModelId,formData,
          {
            headers: {
              'X-Api-Key': API_KEY,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        alert("Cover Pic uploaded Successfully!")
        // Handle response as needed

      } catch (error) {
        console.error('Uploading cover pic:', error);
      }
    }
    if(loggedInUserId==modelDetails.ModelId){
    const update_cover_pic=async () =>{
      try {
  
          const response = await axiosInstance.get(
            `${API_BASE_URL}cover-pic/`+modelDetails.ModelId,
            {
              headers: {
                'X-Api-Key': API_KEY,
                "Content-Type": "multipart/form-data",
              },
            }
          );
          setCoverImg(response.data.data.cover_pic)
          const new_url=response.data.data.cover_pic
          const userData = JSON.parse(localStorage.getItem('userData')) 
          userData.member_details.cover_pic =new_url
          localStorage.setItem('userData', JSON.stringify(userData));
          // Handle response as needed
  
        } catch (error) {
          console.error('Uploading profile pic:', error);
        }
      }
      update_cover_pic();
    }

  }
  const baseUrl = window.location.origin;
  const [openEdit,setOpenEdit] =useState(false)

  const [countryName,setCountryName]= useState("")
  const [jobName,setJobName]= useState("")
  
  const handleModel=(e)=>{
    e.preventDefault()

    const ModelName =name
    const ModelUserName=userName
    const ModelCountryName=countryName
    const ModelJobName = jobName

    let obj={
          ModelName:ModelName,
          ModelUserName:ModelUserName,
          ModelCountryName:ModelCountryName,
          ModelJobName:ModelJobName,
    }

    setModelDetails(obj)
    setOpenEdit(false)
  }


  return (


    <div className='info'>
        <div className="info-cover">
            <img src={coverImg} alt="" />
            <img src={profileImg} alt="" />
            <div className='coverDiv'><IoCameraOutline className='coverSvg' onClick={()=>importCover.current.click()}/></div>
            <div className='profileDiv'><IoCameraOutline className='profileSvg' onClick={()=>importProfile.current.click()}/></div>
        </div>
      

        
        <input type="file"
        name="profile_pic"
        ref={importProfile}
        onChange={handleFile1}
        style={{display:"none"}}
        />
        
        <input type="file" 
        name="cover_pic"
        ref={importCover}
        onChange={handleFile2}
        style={{display:"none"}}
        />
        



        <div className="info-follow">
            <h1>{modelDetails.ModelName}</h1>
            <p>{modelDetails.ModelUserName}</p>

            {/* <Link to="/" className='logout'>
              <BiLogOut />Logout
            </Link> */}
            {/* <button onClick={()=>setOpenEdit(true)}><LiaEdit />Edit Profile</button> */}

            <button hidden={EditMemberButtonVisibility} onClick={()=>window.location.href = baseUrl+"/"+modelDetails.ModelId+'/edit-member/'}><LiaEdit />Edit Profile</button>
            {/* <ModelProfile 
            name={name}
            setName={setName}
            userName={userName}
            setUserName={setUserName}
            countryName={countryName}
            setCountryName={setCountryName}
            jobName={jobName}
            setJobName={setJobName}
            handleModel={handleModel}
            openEdit={openEdit}
            setOpenEdit={setOpenEdit}
            /> */}
          

          <div className="info-details">
            <div className="info-col-1">
              <div className="info-details-list">
                <LocationOnOutlinedIcon />
                <span>{modelDetails.ModelCountryName}</span>
              </div>

              {/* <div className="info-details-list">
                <WorkOutlineRoundedIcon />
                <span>{modelDetails.ModelJobName}</span>
              </div> */}

              <div className="info-details-list">
                <CalendarMonthRoundedIcon />
                <span>{modelDetails.ModelDob}</span>
              </div>
            </div>

            <div className="info-col-2">
              <div>
                <h2>{members_count}</h2>
                <span>Members</span>
              </div>
              <div>
                <h2>{userPostData.length}</h2>
                <span>Posts</span>
              </div>
            </div>

          </div>


        </div>
    </div>
  )
}

export default Info